import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {
  LayoutGrid,
  PanelLeftClose,
  PanelLeftOpen,
  Settings,
} from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const isApplicationsPage =
    location.pathname === "/" || location.pathname === "/applications";
  const isSettingsPage = location.pathname === "/settings";

  const navItems = [
    {
      label: "Applications",
      icon: LayoutGrid,
      href: "/",
      isActive: isApplicationsPage,
    },
    {
      label: "Settings",
      icon: Settings,
      href: "/settings",
      isActive: isSettingsPage,
    },
  ];

  return (
    <div
      className={`flex flex-col h-full border-r bg-background transition-all duration-300 ${
        collapsed ? "w-16" : "w-56"
      }`}
    >
      <div className="p-3 border-b">
        <Button
          variant="ghost"
          onClick={() => setCollapsed(!collapsed)}
          className={cn(
            "w-full justify-start gap-3",
            collapsed && "justify-center px-2"
          )}
        >
          {collapsed ? (
            <PanelLeftOpen className="h-5 w-5 flex-shrink-0" />
          ) : (
            <>
              <PanelLeftClose className="h-5 w-5 flex-shrink-0" />
              <span className="text-muted-foreground">Collapse</span>
            </>
          )}
        </Button>
      </div>

      <nav className="flex-1 p-3 space-y-1">
        {navItems.map((item) => (
          <Link key={item.href} to={item.href}>
            <Button
              variant="ghost"
              className={cn(
                "w-full justify-start gap-3 my-1",
                collapsed && "justify-center px-2",
                item.isActive && "bg-accent text-accent-foreground"
              )}
            >
              <item.icon className="h-5 w-5 flex-shrink-0" />
              {!collapsed && <span>{item.label}</span>}
            </Button>
          </Link>
        ))}
      </nav>
    </div>
  );
}
